





import Vue from "vue";
export default Vue.extend({
  created() {
    this.$store.dispatch("customers/getCustomers");
  },
});
